import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useLang, isRequestedFrom } from 'utils/localisation';
import { usaRegion } from 'define/locale';

export function useOfficesInfo() {
  const {
    allOffice: { nodes: offices },
  } = useStaticQuery(graphql`
    query {
      allOffice {
        nodes {
          id: officeId
          city
          country
          coordinates
          address
          phone
          category {
            name
            icon
          }
          images {
            url
            caption
          }
          hideOnZoomOut
          latOffset
        }
      }
    }
  `);
  const lang = useLang();

  const preparedOffices = useMemo(() => {
    if (lang === 'en' && isRequestedFrom(usaRegion)) {
      const headquartersIcon =
        'https://content.andersenlab.com/common-data/office-category-icons/development-center/1754650781.svg';
      return offices.map(office => {
        if (office.city === 'Dallas') {
          return {
            ...office,
            category: {
              name: 'Headquarters',
              icon: headquartersIcon,
            },
          };
        }
        return office;
      });
    }

    return offices;
  }, [offices, lang]);

  return preparedOffices;
}
